/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import { useSelector } from 'react-redux';
// material
import { Logo } from '@insticator/insticator-ui';
import AsideToggle from './asidetoggle/asidetoggle';
// styles
import injectSheet from 'react-jss';
import styles from './controls_styles';



/* ========== ~~~~~~~~~~ CONTROLS ~~~~~~~~~~ ========== */
const Controls = injectSheet(styles)((props) => {
	const sidebarOpen = useSelector(state => state.app.sidebarOpen);
	return (
		<div id="sidebar-controls" className={`${props.classes.controls} sidebarOpen-${sidebarOpen}`}>
			<div id="sidebar-controls-inner">
        { sidebarOpen ? <Logo name={'insticator'} text={'COOL Media'} /> : <Logo name={'insticator-icon'} text={'COOL Media'} />} 
				<AsideToggle />
			</div>
		</div>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Controls;
